export enum BusEventDialogEnum {
  // Window events
  CLOSE_LAST_MODAL = 'close-last-modal',
  CLOSE_ALL_MODAL = 'close-all-modal',
}
